import { usePatient } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { PatientDemographics } from "@/features/patients";
import { RelatedPersonsSection } from "@/features/patients/components/related-persons-section";

export const Route = createFileRoute("/patients/$patientId/_layout/profile/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patientId } = Route.useParams();
  const { patient } = usePatient(patientId);

  if (!patient) {
    return null;
  }

  return (
    <div className="space-y-6">
      <PatientDemographics patient={patient} />
      <RelatedPersonsSection key={patientId} patientId={patientId} />
    </div>
  );
}
